var keyMirror = require('keymirror');

module.exports = {
    endPoints: {
        GET_CHECKED_IN_CLIENTS: 'api/payment/hypur/get-checked-in-clients',
    },
    actions: keyMirror({
        HYPUR_CHECKEDIN_LIST_LOADED: null,
    }),
    events: keyMirror({
        CHANGE_EVENT: 'changeEvent',
    }),
};



// WEBPACK FOOTER //
// ./ui_src/app/constants/HypurConstants.jsx